import React from 'react';
import { Link } from 'react-router-dom';
import '../css/HomePage.css';

const IconSearch = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
);

const IconInfo = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
);

const IconDevice = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line></svg>
);

const IconAlert = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
);

const HomePage = () => {
  return (
    <div className="home-wrapper">
      <section className="home-hero">
        <div className="home-hero-badge">
          <img
            src="/economicas.png"
            alt="Logo FCE"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        </div>

        <div className="home-hero-content">
          <p className="home-eyebrow">Facultad de Ciencias Económicas · UNCuyo</p>
          <h1 className="home-title">Horarios de Consulta</h1>
          <p className="home-subtitle">
            Accedé a los horarios de apoyo académico de tus docentes.
            Una herramienta diseñada para que organices tu cursado de forma ágil y sencilla.
          </p>

          <div className="home-actions">
            <Link to="/horarios" className="home-primary-btn">
              Ir a horarios de consulta
            </Link>
          </div>
        </div>
      </section>

      <section className="home-grid">
        <article className="home-card">
          <div className="home-card-header">
            <IconInfo />
            <h2 className="home-card-title">¿Qué podés consultar?</h2>
          </div>
          <p className="home-card-text">
            Buscá los horarios de consulta vigentes. Recordá que solo se muestran actividades con
            horarios confirmados por los docentes para el semestre actual.
          </p>
        </article>

        <article className="home-card">
          <div className="home-card-header">
            <IconSearch />
            <h2 className="home-card-title">Cómo buscar</h2>
          </div>
          <p className="home-card-text">Tenés dos modalidades disponibles:</p>
          <ul className="home-list">
            <li>
              <strong>Por actividad:</strong> Filtrá por sede, carrera y plan para ver la oferta completa.
            </li>
            <li>
              <strong>Por profesor:</strong> Escribí el apellido del docente para ir directo a sus horarios.
            </li>
          </ul>
        </article>

        <article className="home-card">
          <div className="home-card-header">
            <IconDevice />
            <h2 className="home-card-title">Visualización flexible</h2>
          </div>
          <p className="home-card-text">Adaptamos la información a tu necesidad:</p>
          <ul className="home-list">
            <li>
              <strong>Vista Tarjetas:</strong> Recomendada para celulares (lectura vertical).
            </li>
            <li>
              <strong>Vista Tabla:</strong> Ideal para computadoras y comparar múltiples días.
            </li>
          </ul>
        </article>

        <article className="home-card">
          <div className="home-card-header">
            <span className="home-card-icon"><IconAlert /></span>
            <h2 className="home-card-title">A tener en cuenta</h2>
          </div>
          <p className="home-card-text">
            <strong>Verificá siempre la sede</strong> antes de buscar. Si una materia no aparece,
            es posible que el horario aún no haya sido informado a la Secretaría Académica.
          </p>
        </article>
      </section>

      <section className="home-footer-grid">
        <article className="home-card home-card-wide">
          <h2 className="home-card-title">Contacto por carrera</h2>
          <p className="home-card-text">
            ¿Falta un horario o tenés dudas académicas? Contactate con tu secretaría:
          </p>

          <div className="home-contact-grid">
            <div className="home-contact-item">
              <span>Administración</span>
              <a href="mailto:secadministracion@fce.uncu.edu.ar?subject=Consulta%20Horarios%20de%20Consulta" className="home-contact-link">secadministracion@fce.uncu.edu.ar</a>
            </div>
            <div className="home-contact-item">
              <span>Economía</span>
              <a href="mailto:sec-eco@fce.uncu.edu.ar?subject=Consulta%20Horarios%20de%20Consulta" className="home-contact-link">sec-eco@fce.uncu.edu.ar</a>
            </div>
            <div className="home-contact-item">
              <span>Contador Público</span>
              <a href="mailto:sec.contador@fce.uncu.edu.ar?subject=Consulta%20Horarios%20de%20Consulta" className="home-contact-link">sec.contador@fce.uncu.edu.ar</a>
            </div>
            <div className="home-contact-item">
              <span>Logística</span>
              <a href="mailto:lic.logistica@fce.uncu.edu.ar?subject=Consulta%20Horarios%20de%20Consulta" className="home-contact-link">lic.logistica@fce.uncu.edu.ar</a>
            </div>
          </div>
        </article>

        <article className="home-card">
          <h2 className="home-card-title">Soporte técnico</h2>
          <p className="home-card-text">
            Si el sistema presenta errores técnicos, notificanos aquí:
          </p>

          <div className="home-contact-grid">
            <div className="home-contact-item">
              <a href="mailto:informatica@fce.uncu.edu.ar?subject=Error%20Sistema%20Horarios" className="home-contact-link">Dirección de Informática</a>
            </div>
            <div className="home-contact-item">
              <a href="mailto:emanuel.quinteros@fce.uncu.edu.ar?subject=Error%20Sistema%20Horarios" className="home-contact-link">Desarrollo (E. Quinteros)</a>
            </div>
          </div>
        </article>
      </section>
    </div>
  );
};

export default HomePage;
